import React from 'react';

import { Zoom, Paper, Box, Theme } from '@material-ui/core';
import { PublishRounded } from '@material-ui/icons';

import { useSnackbar } from 'notistack';

import { FileSelectorData } from './FileSelectorContext';

export interface FileSelectorDropProps {
  open: boolean;
  onClose: () => void;
}

const fileSelectorDrop = {
  dropZonePositioner: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10,
  },
  dropZoneWrapper: {
    height: `calc(100% - ${(12 + 3) * 2}px)`,
    border: 3,
    borderStyle: 'dashed',
    background: 'rgba(0, 0, 0, 0.12)',
    margin: '12px',
    pointerEvents: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: '300px',
    height: '300px',
    fill: '#000',
    stroke: '#fff',
    strokeWidth: 0.2,
  },
} as const;

export const FileSelectorDrop = (props: FileSelectorDropProps) => {
  const fileSelectorData = React.useContext(FileSelectorData);

  const { enqueueSnackbar } = useSnackbar();

  return (
    <Box
      style={{
        ...fileSelectorDrop.dropZonePositioner,
        pointerEvents: props.open ? 'auto' : 'none',
      }}
      onDragOver={(event: React.DragEvent<HTMLDivElement>) => {
        event.stopPropagation();
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
      }}
      onDragLeave={(event: React.DragEvent<HTMLDivElement>) => {
        event.stopPropagation();
        event.preventDefault();
        props.onClose();
      }}
      onDrop={(event: React.DragEvent<HTMLDivElement>) => {
        event.stopPropagation();
        event.preventDefault();

        let files = [] as File[];

        // Check if dropped data is a file
        for (let i = 0; i < event.dataTransfer.files.length; i++) {
          const file = event.dataTransfer.files[i];

          if (file && file.size > 0) files.push(file);
          else
            enqueueSnackbar('Das Dateiformat kann nicht hochgeladen werden', {
              variant: 'error',
            });
        }

        if (files.length) fileSelectorData.onUpload(files);

        props.onClose();
      }}
      component="div"
    >
      <Zoom in={props.open}>
        <Paper style={fileSelectorDrop.dropZoneWrapper}>
          <PublishRounded style={fileSelectorDrop.icon} />
        </Paper>
      </Zoom>
    </Box>
  );
};
